// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { IconWrapper } from "@insite/mobius/Icon";
import { miniCartLineStyles } from "@sc/App/Components/MiniCart/MiniCartLine";
import { createHorizontalSmallHeadingAndTextStyles } from "@sc/App/SharedStyles/smallHeadingAndTextStyles";
import { color, ellipsis, xScreen } from "@sc/XDL/Utilities";
import { css } from "styled-components";

miniCartLineStyles.cartLine = {
    css: css`
        display: flex;
        position: relative;
        margin-bottom: 16px;
        justify-content: flex-start;
    `,
};
miniCartLineStyles.imageWrapper = {
    css: css`
        overflow: hidden;
        flex-shrink: 0;
        display: flex;
        justify-content: center;
    `,
};
miniCartLineStyles.cartLineImage = {
    css: css`
        height: 91px;
        width: 91px;
        img {
            height: auto;
            width: 100%;
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
        }
    `,
};
miniCartLineStyles.detailsWrapper = {
    css: css`
        width: 100%;
        display: flex;
        gap: 12px;
    `,
};
miniCartLineStyles.imageAndDescriptionWrapper = {
    css: css`
        display: flex;
        width: 100%;
    `,
};
miniCartLineStyles.contentWrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        width: 100%;
    `,
};

miniCartLineStyles.lineDescription = {
    typographyProps: {
        size: 14,
        lineHeight: "16px",
        weight: "bold",
        css: css`
            ${ellipsis(2)}
            letter-spacing: 0;
            text-decoration: none;
            &&&& {
                color: ${color("text.main")};
                &:hover {
                    text-decoration: none;
                    color: ${color("primary.main")};
                }
            }
        `,
    },
    css: css`
        margin-bottom: 8px;
        align-items: baseline;
    `,
};
miniCartLineStyles.qtyWrapper = {
    css: css`
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    `,
};

miniCartLineStyles.basicProductPriceStyles = {
    priceWrapper: {
        css: css`
            display: flex;
            align-items: baseline;
        `,
    },
    price: {
        priceText: {
            weight: "bold",
            size: 16,
            css: css`
                line-height: 22px;
            `,
        },
        unitOfMeasure: {
            unitOfMeasureText: {
                size: 12,
                weight: 400,
                css: css`
                    white-space: nowrap;
                    letter-spacing: 0;
                    line-height: 13px;
                    margin: 0;
                `,
            },
        },
    },
};

miniCartLineStyles.removeCartLineLink = {
    css: css`
        margin-right: 4px;
        ${IconWrapper}, svg {
            color: ${color("primary")};
            &:hover {
                opacity: 0.66;
            }
        }
    `,
};

miniCartLineStyles.errorMessagesWrapper = {
    css: css`
        width: 100%;
        margin-top: 10px;
        & > div:not(:last-child) {
            margin-bottom: 12px;
        }
    `,
};
miniCartLineStyles.partNumbersWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        gap: 12px;
        margin-bottom: 8px;
    `,
};
miniCartLineStyles.erpNumberTextSmallHeading = {
    ...createHorizontalSmallHeadingAndTextStyles({
        wrapper: {
            css: css`
                width: auto;
            `,
        },
    }),
};
miniCartLineStyles.notify = {
    css: css`
        margin-bottom: 12px;
    `,
};
miniCartLineStyles.qtyPriceWrapper = {
    css: css`
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        gap: 38px;
    `,
};
miniCartLineStyles.imageLink = {
    css: css`
        align-items: baseline;
    `,
};
